import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetCompanyDetailsApi,
GetWebsiteDetailsApi
} from "../api/custom-domain-api/CustomDomainApi";

// Async thunks for API calls
export const getWebsiteDetails = createAsyncThunk(
  "custom/getWebsiteDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetWebsiteDetailsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const GetCompanyDetails = createAsyncThunk(
  "custom/GetCompanyDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetCompanyDetailsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);



// Initial state
const initialState = {
    websiteDetails:null,
    companyDetails:null,
    loading: false,
  error: null,

};

// Slice definition
const CustomDomainSlice = createSlice({
  name: "custom",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getWebsiteDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWebsiteDetails.fulfilled, (state,action) => {
        state.loading = false;
        // debugger
        state.websiteDetails = action.payload?.response;
      })
      .addCase(getWebsiteDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

        builder
      .addCase(GetCompanyDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetCompanyDetails.fulfilled, (state,action) => {
        state.loading = false;
        // debugger
        state.companyDetails = action.payload?.response;
      })
      .addCase(GetCompanyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
     
  },
});

export default CustomDomainSlice.reducer;
